import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=2696b89d&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=2696b89d&prod&scoped=true&lang=css&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=2696b89d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2696b89d",
  null
  
)

export default component.exports